var GridArrangerOptions        = require("app/ui/repeaters/GridArrangerOptions"),
    EpisodeThumbnail           = require("app/ui/thumbnails/EpisodeThumbnail"),
    Repeater                   = require("enyo-ui/Repeater"),
    RepeaterArrayDataAdapter   = require("enyo-ui/RepeaterArrayDataAdapter"),
    RepeaterDrawLoopSupport    = require("enyo-ui/RepeaterDrawLoopSupport"),
    RepeaterPaddedGridArranger = require("enyo-ui/RepeaterPaddedGridArranger"),
    ThumbnailPlaceholder       = require("app/ui/thumbnails/ThumbnailPlaceholder"),
    frameThrottle              = require("enyo-perf/utils").frameThrottle,
    get                        = require("object-path").get,
    kind                       = require("enyo/kind");

require("./SingleSeasonGridRow.less");
require("app/theme/IconButton--media-row.less");
require("app/theme/styles/popups/Popup--plain.less");

module.exports = kind(/** @lends  app.SeriesPage.SingleSeasonGridRow.prototype */ {

    /**
     * @private
     */
    name: "app.SeriesPage.SingleSeasonGridRow",

    /**
     * @private
     */
    classes: "app-series-page-single-season-grid-row",

    /**
     * The dataset
     *
     * @type  {?Object}
     * @public
     */
    data: null,

    /**
     * The state of this page.
     *
     * @type  {?Object}
     * @public
     */
    state: null,

    /**
     * @private
     */
    components: [{
        name:       "header",
        classes:    "app-series-page-single-season-grid-row__header",
        components: [{
            name:    "title",
            tag:     "h2",
            classes: "app-series-page-single-season-grid-row__title"
        }]
    }, {
        name:            "grid",
        kind:            Repeater,
        classes:         "app-series-page-single-season-grid-row__grid",
        mixins:          [RepeaterDrawLoopSupport],
        childFormFactor: "landscape",
        childSize:       "md",
        showTitles:      true,
        dataAdapterKind: RepeaterArrayDataAdapter,
        arrangerKind:    RepeaterPaddedGridArranger,
        arrangerOptions: GridArrangerOptions,

        /**
         * The kind that will be rendered for each placeholder.
         *
         * @type {enyo.Control}
         * @public
         */
        placeholderKind: ThumbnailPlaceholder,

        /**
         * Optional extra options to merge into the placeholder kind at creation
         * time.
         *
         * @type {Object=}
         * @public
         */
        placeholderOptions: {
            bindings: [{
                from: ".repeater.showTitles",
                to:   ".showTitle",

                /**
                 * If the repeater does not provide any info, just show the
                 * current value.
                 *
                 * @param   {?boolean}  showTitle Title visibility.
                 * @return  {boolean}   Whether to show the title.
                 * @private
                 */
                transform: function(showTitle) {
                    if (showTitle === undefined) {
                        return this.get("showTitle");
                    }
                    else {
                        return showTitle;
                    }
                }
            }, {
                from: ".repeater.childFormFactor",
                to:   ".formFactor",

                /**
                 * If the repeater does not provide any info, just show the
                 * current value.
                 *
                 * @param   {?string}  formFactor Cover form-factor.
                 * @return  {string}   The desired form-factor.
                 * @private
                 */
                transform: function(formFactor) {
                    if (formFactor === undefined) {
                        return this.get("formFactor");
                    }
                    else {
                        return formFactor;
                    }
                }
            }]
        },

        /**
         * The kind that will be rendered for each item in the dataset.
         *
         * @type  {enyo.Control}
         * @public
         */
        childKind: EpisodeThumbnail,

        /**
         * Optional extra options to merge into the child kind at creation time.
         *
         * @type {Object}
         * @public
         */
        childOptions: {
            bindings: [{
                from: ".repeater.showTitles",
                to:   ".showTitle",

                /**
                 * If the repeater does not provide any info, just show the
                 * current value.
                 *
                 * @param   {?boolean}  showTitle Title visibility.
                 * @return  {boolean}   Whether to show the title.
                 * @private
                 */
                transform: function(showTitle) {
                    if (showTitle === undefined) {
                        return this.get("showTitle");
                    }
                    else {
                        return showTitle;
                    }
                }
            }, {
                from: ".repeater.childFormFactor",
                to:   ".formFactor",

                /**
                 * If the repeater does not provide any info, just show the
                 * current value.
                 *
                 * @param   {?string}  formFactor Cover form-factor.
                 * @return  {string}   The desired form-factor.
                 * @private
                 */
                transform: function(formFactor) {
                    if (formFactor === undefined) {
                        return this.get("formFactor");
                    }
                    else {
                        return formFactor;
                    }
                }
            }]
        },
        drawAsync: true
    }],

    /**
     * @private
     */
    bindings: [{
        from: ".repeater.state",
        to:   ".state"
    }],

    /**
     * @private
     */
    observers: {
        update: ["data"]
    },

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.update = frameThrottle(this.bindSafely(this.update));
            sup.apply(this, arguments);
            this.update();
        };
    }),

    /**
     * Update the component in response to state changes.
     *
     * @public
     */
    update: function() {
        var data = this.data || {};

        this.$.title.set("content", get(data, "meta.title", null) || "");
        this.$.grid.set("data", get(data, "children", []));
    }

});
